module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-dialog', {
    attrs: {
      "open": _vm.showDialog
    },
    on: {
      "close": _vm.close
    }
  }, [(_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.errorMsg
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {}
  }, [_c('mu-radio', {
    attrs: {
      "name": "trainScope",
      "label": "所有可选训练",
      "nativeValue": "all-trains"
    },
    model: {
      value: (_vm.trainScope),
      callback: function($$v) {
        _vm.trainScope = $$v
      },
      expression: "trainScope"
    }
  }), _vm._v(" "), _c('mu-radio', {
    attrs: {
      "name": "trainScope",
      "label": "训练方案内训练",
      "nativeValue": "planned-trains"
    },
    model: {
      value: (_vm.trainScope),
      callback: function($$v) {
        _vm.trainScope = $$v
      },
      expression: "trainScope"
    }
  }), _vm._v(" "), _c('mu-radio', {
    attrs: {
      "name": "trainScope",
      "label": "系统推荐训练",
      "nativeValue": "recommended-trains"
    },
    model: {
      value: (_vm.trainScope),
      callback: function($$v) {
        _vm.trainScope = $$v
      },
      expression: "trainScope"
    }
  })], 1), _vm._v(" "), _c('trainMenu', {
    ref: "trainmenu",
    attrs: {
      "trainCategories": _vm.trainCategories
    },
    on: {
      "category-path-updated": _vm.onTrainCategoryChoose
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-y": "auto",
      "min-height": "50vh",
      "max-height": "50vh",
      "display": "flex",
      "flex-direction": "column",
      "align-items": "stretch",
      "justify-content": "stretch"
    }
  }, [(_vm.showAddPlanRoute) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "flex-grow": "1"
    }
  }, [_vm._v("\n        当前没有训练方案，"), _c('span', {
    on: {
      "click": function($event) {
        _vm.toTrainPlan(_vm.caseId)
      }
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "underline",
      "cursor": "pointer"
    }
  }, [_vm._v("添加方案")])])]) : _c('card-list', {
    attrs: {
      "listItems": _vm.currentTrainCategory ? _vm.currentTrainCategory.games : [],
      "itemComponent": _vm.trainCard
    },
    on: {
      "list-item-clicked": _vm.onTrainClicked
    }
  })], 1), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "color": "#999"
    },
    attrs: {
      "slot": "actions",
      "label": "取消"
    },
    on: {
      "click": _vm.cancelhandler
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "width": "160px",
      "margin-left": "20px"
    },
    attrs: {
      "slot": "actions",
      "disabled": Object.values(_vm.selectedGames).length === 0,
      "primary": ""
    },
    on: {
      "click": _vm.goTrain
    },
    slot: "actions"
  }, [_c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("\n      " + _vm._s(("去训练(已选" + (Object.values(_vm.selectedGames).length) + "个)")) + "\n      ")])]), _vm._v(" "), _c('mu-flat-button', {
    class: [{
      'red': _vm.timeWarn
    }, {
      'orange': !_vm.timeWarn
    }],
    attrs: {
      "slot": "actions",
      "label": _vm.trainCounts,
      "primary": ""
    },
    slot: "actions"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49b732e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/times/timeModalSelect.vue
// module id = 986
// module chunks = 2